import randomNumber from "random-number";

export const rng = {
    getRandomCharacters,
    generateEmailAddress,
    getRandomId,
    getRandomInteger,
    getUniqueStrings
}

export type characterTypes = 'lower' | 'upper' | 'numeric';

function getRandomCharacters(amount: number, types: characterTypes[] = ['lower','upper','numeric']): string {
    if (types.length === 0)
        throw new Error('Must select at least one type of characters');

    const upperCaseCharacters = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
    ];

    const pool: string[] = [];
    if (types.find(t => t === 'upper')) {
        pool.push(...upperCaseCharacters);
    }
    if (types.find(t => t === 'lower'))
        pool.push(...upperCaseCharacters.map(c => c.toLowerCase()));
    if (types.find(t => t === 'numeric'))
        for (let i = 0; i < 10; i++) {
            pool.push(i.toString());
        }

    const result: string[] = [];
    for (let i = 0; i < amount; i++) {
        result.push(pool[getRandomInteger(0, pool.length - 1)]);
    }

    return result.join('');
}

function generateEmailAddress(){
    return `new${getRandomId()}@testing.test`;
}

const rn = randomNumber.generator;

function getRandomId(prefix?: string): string {
    const randomInteger = rn({
        max: 999999999,
        min: 100000000,
        integer: true
    });
    //return `${(prefix || '') + new Date().getTime().toString() + randomInteger().toString()}`;
    return (prefix || '') + randomInteger();
}

function getRandomInteger(min: number, max: number): number {
    return randomNumber({
        max: max,
        min: min,
        integer: true
    });
}

function getUniqueStrings(vals:string[], config?:{ trim?:boolean, ignoreCase?:boolean, ignoreEmpty?:boolean})
{
    function applyConfig(before:string){
        let after = before;
        if(config?.trim)
            after = after.trim();
        if(config?.ignoreCase)
            after = after.toLowerCase();
        return after;
    }

    const uniqueVals:string[] = [];
    for(let i=0; i<vals.length; i++){
        const val = applyConfig(vals[i]);
        if(uniqueVals.find(v => applyConfig(v) === val) === undefined){
            if(val !== '' || !config?.ignoreEmpty)
                uniqueVals.push(vals[i]);
        }
    }
    return uniqueVals;
}